import HostInquirer from './HostInquirer'

class PopupsDecorator extends HostInquirer {
    constructor(context) {
        super(context)

        this.initiated = false
    }

    init() {
        if (this.initiated) {
            return
        }

        this.initiated = true

        this.elements = this.findAndDecorateElements()

        this.attachEventListeners({
            eventHandler: this.onElementClick.bind(this),
        })
    }

    findAndDecorateElements() {
        const prefixes = [
            { prefix: 'PicoPlan', type: 'optionId' },
            { prefix: 'PicoPopup', type: 'popupId' },
            { prefix: 'PicoProduct', type: 'optionId' },
        ]

        const buildRegex = (prefix = '') => new RegExp(`${prefix}_[^\\s]+`, 'i')

        const getElements = (prefix = '') => (
            this.getAllElementsFromQuery(`[class*=${prefix}]`)
                .filter((element) => (
                    element.className.match(buildRegex(prefix))
                ))
        )

        const fetchShortCode = (string = '', prefix) => {
            const targetClass = (string.match(buildRegex(prefix))?.[0] || '')
            const shortCode = targetClass.split('_')[1]
            return shortCode
        }

        let allElements = []
        prefixes.forEach(({ prefix, type }) => {
            const elements = getElements(prefix)
            allElements = [...allElements, ...elements]
            elements.forEach((element) => {
                const data = {
                    [type]: fetchShortCode(element.className, prefix),
                }
                element.data = data
                Array.from(element.children).forEach((childElement) => {
                    // eslint-disable-next-line no-param-reassign
                    childElement.data = data
                })
            })
        })
        return allElements
    }

    attachEventListeners({
        event = 'click',
        eventHandler = () => { },
    }) {
        this.elements.forEach((element) => {
            element.removeEventListener(event, eventHandler)
            element.addEventListener(event, eventHandler)
        })
    }

    onElementClick(e) {
        e.preventDefault()
        e.stopPropagation()

        this.context.Pico.handlePopupClick(e?.target?.data)
    }
}

export default PopupsDecorator
